export const createSubPageIdForStoreDialog = (dialogType, templatedAppId, templateInstanceId, environment, source, userHasCopilotLicense) => {
    return {
        supportedElementInfo: {
            staticTabs: [
                {
                    scopes: ['personal'],
                },
            ],
        },
        isUpgrade: dialogType === 'UPGRADE',
        allowInstall: dialogType === 'INSTALL',
        templatedAppId: templatedAppId,
        templateInstanceId: templateInstanceId,
        environment: environment,
        source: source,
        userHasCopilotLicense: userHasCopilotLicense,
    };
};
//# sourceMappingURL=createSubPageIdForStoreDialogs.js.map